export const HTTP = {
  STATUS: {
    BAD_REQUEST: 422,
  },
} as const;
